import api, { apiRaw } from "./api";
class DoacaoService {
    static async salvar(doacao, url) {
        const res = await apiRaw.post(url, doacao);
        return res.data;
    }
    static async minhasDoacoesRecebidas() {
        const res = await api.get("restrito/doacoes/lista-doacoes-recebidas");
        return res.data;
    }
    static async minhasDoacoesRealizadas() {
        const res = await api.get("restrito/doacoes/lista-doacoes-realizadas");
        return res.data;
    }
    static async cancelarRecorrencia(id) {
        const res = await apiRaw.post(`restrito/doacoes/${id}/cancelar-recorrencia`, {
            ajax: true,
        });
        return res.data;
    }
}
export default DoacaoService;
